module.exports = __webpack_public_path__ + "img/img_07.26ac6447.webp";